import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_5c0ij053zo: FaireBrandEntity = {
  token: "b_5c0ij053zo",
  type: "brand",
  name: "Leto Accessories",
  avatarUrl:
    "https://cdn.faire.com/fastly/0b90cee2b78a6a0e8913bee92e1fe9fb631d79c954560834ee930233bbbe5ee5.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/fcb76ab127e625ff5d79291b3f9a834006fc3fcef8f8146a5b176fb162b493ba.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/0b90cee2b78a6a0e8913bee92e1fe9fb631d79c954560834ee930233bbbe5ee5.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/fcb76ab127e625ff5d79291b3f9a834006fc3fcef8f8146a5b176fb162b493ba.jpeg",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 50,
  rating: 4.9,
  reviewCount: 3990,
  isTopShop: true,
  isInsider: true,
  description:
    "Leto Collection specializes in Bohemian style bralettes and accessories. A premiere brand that focuses on trendiness and high quality fashion goods at factory direct wholesale prices. Leto is in the business of allowing boutiques to flourish by providing the latest trends and boutique profitable prices. ",
  meta: {
    source: "api",
    importedAt: "2026-05-06T17:57:46.985Z",
    importedBy: "entity-db-cli",
  },
};
